import React from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    Typography,
    List,
    ListItem,
    ListItemText
} from '@material-ui/core';

/**
 * Format minutes ago into human readable string
 */
function formatMinutesAgo(minutes) {
    if (minutes < 1) {
        return 'just now';
    }
    if (minutes === 1) {
        return '1 minute ago';
    }
    return `${minutes} minutes ago`;
}

/**
 * Modal shown when trying to login as a guest that another agent is logged into
 */
function SoftLockModal({ showModal, MODAL_TYPE, lockHolders = [], onForceLogin, onCancel }) {
    const handleForceLogin = () => {
        onForceLogin?.();
        showModal(MODAL_TYPE.NONE);
    };

    const handleCancel = () => {
        onCancel?.();
        showModal(MODAL_TYPE.NONE);
    };

    const isSingleAgent = lockHolders.length === 1;

    return (
        <Dialog open maxWidth="sm" fullWidth onClose={handleCancel}>
            <DialogTitle>Another Agent Is Logged Into This Guest</DialogTitle>
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    {isSingleAgent
                        ? 'Another agent is currently logged into this guest:'
                        : 'Other agents are currently logged into this guest:'}
                </Typography>
                <List dense>
                    {lockHolders.map((holder, index) => (
                        <ListItem key={holder.agentId || index}>
                            <ListItemText
                                primary={holder.name}
                                secondary={`${holder.email} - Active ${formatMinutesAgo(holder.minutesAgo)}`}
                            />
                        </ListItem>
                    ))}
                </List>
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                    You can dismiss and wait for them to finish, or continue anyway.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="default">
                    Dismiss
                </Button>
                <Button onClick={handleForceLogin} variant="contained" color="primary">
                    Continue Anyway
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SoftLockModal;
